function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

var tooltipStyles = function tooltipStyles(hideBg) {
  return "  \n  .tooltip-custom {\n    background: ".concat(hideBg ? 'none' : 'var(--grey-000-white, #fff)', ";\n    color: #333;\n    border-radius: 16px;\n    opacity: 1;\n    box-shadow: ").concat(hideBg ? 'none' : '' + '0px -4px 24px 0px rgba(78, 98, 126, 0.08), ' + '0px 16px 24px 0px rgba(78, 98, 126, 0.16);', ";\n    padding: ").concat(hideBg ? 'none' : 'var(--8pt-Grid-16px, 16px) var(--8pt-Grid-24px, 24px)', ";\n    opacity: 1;\n    z-index: ").concat(hideBg ? '99999' : '9999', ";\n    max-width: 300px;\n  }\n\n  .tooltip-custom .react-tooltip-arrow {\n    background-color: #fff;\n    border-width: 0;\n  }\n\n  @media (max-width: 767px) {\n    .tooltip-custom {\n      max-width: min(320px, 90vw);\n    }\n  }\n");
};

export var PopoverV3 = function PopoverV3(_ref) {
  var content = _ref.content,
      isOpen = _ref.isOpen,
      show = _ref.show,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position,
      onClose = _ref.onClose,
      onOutsideClick = _ref.onOutsideClick,
      _ref$eventType = _ref.eventType,
      eventType = _ref$eventType === void 0 ? 'click' : _ref$eventType,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$hideArrow = _ref.hideArrow,
      hideArrow = _ref$hideArrow === void 0 ? false : _ref$hideArrow,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 10 : _ref$offset,
      attachTo = _ref.attachTo,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? true : _ref$usePortal,
      portalContainer = _ref.portalContainer,
      _ref$hideBg = _ref.hideBg,
      hideBg = _ref$hideBg === void 0 ? false : _ref$hideBg;
  var shouldShow = isOpen !== undefined ? isOpen : show;

  var _useState = useState("tooltip-".concat(Math.random().toString(36).substr(2, 9))),
      _useState2 = _slicedToArray(_useState, 1),
      tooltipId = _useState2[0];

  var tooltipRef = useRef(null);

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      portalRoot = _useState4[0],
      setPortalRoot = _useState4[1];

  useEffect(function () {
    var styleTag = document.createElement('style');
    styleTag.textContent = tooltipStyles(hideBg);
    document.head.appendChild(styleTag);
    return function () {
      if (document.head.contains(styleTag)) {
        document.head.removeChild(styleTag);
      }
    };
  }, []);
  useEffect(function () {
    if (usePortal) {
      var container = portalContainer || document.body;
      setPortalRoot(container);
    } else {
      setPortalRoot(null);
    }
  }, [usePortal, portalContainer]);
  useEffect(function () {
    if (shouldShow) {
      setTimeout(function () {
        tooltipRef.current = document.getElementById(tooltipId);
      }, 50);
    }
  }, [shouldShow, tooltipId]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var tooltipElement = tooltipRef.current || document.getElementById(tooltipId);
      var clickedInsideTooltip = tooltipElement && tooltipElement.contains(event.target);
      var clickedInsideTrigger = attachTo && attachTo.contains(event.target);

      if (shouldShow && !clickedInsideTooltip && !clickedInsideTrigger) {
        if (onClose) onClose();
        if (onOutsideClick) onOutsideClick();
      }
    };

    if (eventType === 'click' && shouldShow) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [shouldShow, onClose, onOutsideClick, eventType, tooltipId, attachTo]);

  var renderTooltip = function renderTooltip() {
    var tooltip = /*#__PURE__*/React.createElement(Tooltip, {
      id: tooltipId,
      isOpen: shouldShow,
      clickable: true,
      delayShow: delay,
      delayHide: 0,
      offset: offset,
      noArrow: hideArrow,
      style: {
        display: shouldShow ? 'block' : 'none'
      },
      className: "tooltip-custom ".concat(className),
      render: function render() {
        return typeof content === 'string' ? null : content;
      },
      place: position
    });

    if (usePortal && portalRoot) {
      return /*#__PURE__*/createPortal(tooltip, portalRoot);
    }

    return tooltip;
  };

  useEffect(function () {
    if (attachTo) {
      attachTo.setAttribute('data-tooltip-id', tooltipId);
      attachTo.setAttribute('data-tooltip-place', position);

      if (typeof content === 'string') {
        attachTo.setAttribute('data-tooltip-html', content);
      }
    }
  }, [attachTo, tooltipId, position, content]);

  if (attachTo) {
    return renderTooltip();
  }

  return renderTooltip();
};